module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAApklEQVQokZXOMWoCURSF4W+GSWHhZAEWCaRzD3YBawPBFeRZBmYjsbMRXIHZTbooWFhZmUqwSfNGBn0D4w+3Oee/l5uFEDT4wCce8YcvLOuyaIgVxnH2GGCFfly6yL0oD+NFceEdP1jglMfiCbuGWHOM+XN9+QUjlHh1Sxn7cxZCOOA7IV3zVuABsw7yNG8p5qmwTZ7cIydpk6t75HUqLLDFpsMXv/9JVxsYfCIcLAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/mm.png
// module id = 5YOg
// module chunks = 1